import { useMutation, useQueryClient } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastExito, toastInfo } from "@/lib/toast";
import {
  cambiarEstadoCategoria,
  crearCategoria,
  editarCategoria,
  eliminarCategoria,
  type CrearCategoriaInput,
  type EditarCategoriaInput,
} from "../services/categorias-documento-service";

export function useCrearCategoria(opts?: { onCreada?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CrearCategoriaInput) => crearCategoria(input),
    onSuccess: (cat) => {
      toastExito({ title: `Categoría "${cat.nombre}" creada`, message: "Disponible en el catálogo." });
      void qc.invalidateQueries({ queryKey: qk.adminCategoriasDocumento });
      opts?.onCreada?.();
    },
    onError: toastErrorApi,
  });
}

export function useEditarCategoria(opts?: { onEditada?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: EditarCategoriaInput }) => editarCategoria(id, input),
    onSuccess: (cat) => {
      toastExito({ title: `Categoría "${cat.nombre}" actualizada`, message: "Cambios guardados." });
      void qc.invalidateQueries({ queryKey: qk.adminCategoriasDocumento });
      opts?.onEditada?.();
    },
    onError: toastErrorApi,
  });
}

export function useCambiarEstadoCategoria() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, activa }: { id: string; activa: boolean }) => cambiarEstadoCategoria(id, activa),
    onSuccess: (cat) => {
      if (cat.activa) {
        toastExito({ title: "Categoría activada", message: `"${cat.nombre}" ahora está disponible.` });
      } else {
        toastInfo({ title: "Categoría desactivada", message: `"${cat.nombre}" ahora está deshabilitada.` });
      }
      void qc.invalidateQueries({ queryKey: qk.adminCategoriasDocumento });
    },
    onError: toastErrorApi,
  });
}

export function useEliminarCategoria(opts?: { onEliminada?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => eliminarCategoria(id),
    onSuccess: () => {
      toastExito({ title: "Categoría eliminada", message: "Quitada del catálogo." });
      void qc.invalidateQueries({ queryKey: qk.adminCategoriasDocumento });
      opts?.onEliminada?.();
    },
    onError: toastErrorApi,
  });
}
